import {
  isoStringToObject,
  mapRepliconDateToMidnightUTCString
} from '~/modules/common/dates/convert';

const mapUserProfileCertificateToCertificate = userProfileCertificate => {
  const {
    nudgeId,
    name,
    issueDate,
    expiryDate,
    authority
  } = userProfileCertificate;

  return {
    id: null,
    uri: null,
    name,
    issueDate: issueDate ? isoStringToObject(issueDate) : null,
    expiryDate: expiryDate ? isoStringToObject(expiryDate) : null,
    issuer: authority ?? null,
    expires: expiryDate ? true : null,
    credentialId: null,
    credentialUrl: null,
    nudgeId
  };
};

export const mapCertificateKey = certificate =>
  [
    certificate.name,
    certificate.issuer || '',
    certificate.issueDate
      ? mapRepliconDateToMidnightUTCString(certificate.issueDate)
      : '',
    certificate.expiryDate
      ? mapRepliconDateToMidnightUTCString(certificate.expiryDate)
      : ''
  ].join('|');

export const combineCertificatesAndUserProfileCertificates = ({
  certificates,
  userProfileCertificates
}) => {
  const certificateMap = certificates.reduce((acc, certificate) => {
    acc[mapCertificateKey(certificate)] = certificate;

    return acc;
  }, {});

  const filteredNewCertificates = userProfileCertificates.reduce(
    (acc, userProfileCertificate) => {
      const newCertificate = mapUserProfileCertificateToCertificate(
        userProfileCertificate
      );

      if (!certificateMap[mapCertificateKey(newCertificate)]) {
        acc.push({ ...newCertificate, isDelaRecommendation: true });
      }

      return acc;
    },
    []
  );

  return [...certificates, ...filteredNewCertificates];
};
